'use strict';

angular.module('clientDashboardApp').directive('selectize', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attrs, ngModel) {
            $timeout(function () {
                var $element = $(elem).selectize({plugins: ['remove_button']});

                $element.selectize().on('change', function () {
                    scope.$apply(function () {
                        var newValue = $element.val();
                        ngModel.$setViewValue(newValue);
                    });
                });
            });
        }
    }
}]);
